/**
 * NYC Master Itinerary Locations
 * 75 locations across Manhattan, Brooklyn, Queens, Staten Island, and Bronx
 * Categories: Iconic Landmarks, Food & Dining, Wellness & Lifestyle
 */

export const NYC_MASTER_LOCATIONS = [
  // ICONIC LANDMARKS & TOURS (24 locations)
  {
    id: 'nyc-landmark-1',
    eventTitle: 'Statue of Liberty',
    venueName: 'Liberty Island',
    'location/address': 'Liberty Island, NY 10004',
    latitude: 40.6892,
    longitude: -74.0445,
    category: 'Iconic Landmarks',
    subcategory: 'Tours',
    startTime: '09:00',
    endTime: '17:00',
    isReservationsNeeded: true,
    typicalHours: '9 AM - 5 PM',
    description: 'Iconic symbol of freedom and democracy. Take the ferry to Liberty Island for an up-close view of this world-famous monument.',
    coverArtUrl: '/images/statue-of-liberty.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-2',
    eventTitle: 'Summit One Vanderbilt',
    venueName: 'One Vanderbilt',
    'location/address': '45 E 42nd St, New York, NY 10017',
    latitude: 40.7530,
    longitude: -73.9785,
    category: 'Iconic Landmarks',
    subcategory: 'Observatory',
    startTime: '09:00',
    endTime: '00:00',
    isReservationsNeeded: true,
    typicalHours: '9 AM - 12 AM',
    description: 'New York\'s highest outdoor observation deck with stunning 360-degree views of Manhattan.',
    coverArtUrl: '/images/summit-vanderbilt.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-3',
    eventTitle: 'Secrets of Grand Central Station',
    venueName: 'Grand Central Terminal',
    'location/address': 'Grand Central Terminal, New York, NY 10017',
    latitude: 40.7527,
    longitude: -73.9772,
    category: 'Iconic Landmarks',
    subcategory: 'Tours',
    startTime: '10:00',
    endTime: '18:00',
    isReservationsNeeded: true,
    typicalHours: 'Tours Varies',
    description: 'Discover the hidden secrets and architectural marvels of this historic transportation hub.',
    coverArtUrl: '/images/grand-central.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-4',
    eventTitle: 'Architecture Tour',
    venueName: 'Midtown Manhattan',
    'location/address': 'Varies (Midtown focus suggested)',
    latitude: 40.7566,
    longitude: -73.9793,
    category: 'Iconic Landmarks',
    subcategory: 'Tours',
    startTime: '10:00',
    endTime: '16:00',
    isReservationsNeeded: true,
    typicalHours: 'Varies',
    description: 'Explore the architectural wonders of Midtown Manhattan with expert guides.',
    coverArtUrl: '/images/architecture-tour.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-5',
    eventTitle: 'Stephen Schwartzman NY Public Library',
    venueName: 'NY Public Library',
    'location/address': '476 5th Ave, New York, NY 10018',
    latitude: 40.7533,
    longitude: -73.9818,
    category: 'Iconic Landmarks',
    subcategory: 'Cultural',
    startTime: '10:00',
    endTime: '18:00',
    isReservationsNeeded: false,
    typicalHours: '10 AM - 6 PM',
    description: 'Magnificent Beaux-Arts building housing one of the world\'s greatest research libraries.',
    coverArtUrl: '/images/nypl.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-6',
    eventTitle: 'Times Square',
    venueName: 'Times Square',
    'location/address': 'Broadway & 7th Ave, New York, NY 10036',
    latitude: 40.7580,
    longitude: -73.9855,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: '24/7',
    description: 'The crossroads of the world - experience the energy and lights of Times Square.',
    coverArtUrl: '/images/times-square.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-7',
    eventTitle: 'Radio City Music Hall Rooftop Garden',
    venueName: 'Radio City Music Hall',
    'location/address': '1260 6th Ave, New York, NY 10020',
    latitude: 40.7597,
    longitude: -73.9790,
    category: 'Iconic Landmarks',
    subcategory: 'Tours',
    startTime: '10:00',
    endTime: '18:00',
    isReservationsNeeded: true,
    typicalHours: 'Varies by event/tour',
    description: 'Hidden rooftop garden with stunning city views above the famous music hall.',
    coverArtUrl: '/images/radio-city.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-8',
    eventTitle: 'Midtown Indoor Garden',
    venueName: '601 Lexington Ave',
    'location/address': '601 Lexington Ave, New York, NY 10022',
    latitude: 40.7588,
    longitude: -73.9719,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '08:00',
    endTime: '18:00',
    isReservationsNeeded: false,
    typicalHours: '8 AM - 6 PM',
    description: 'Peaceful indoor garden oasis in the heart of Midtown Manhattan.',
    coverArtUrl: '/images/indoor-garden.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-9',
    eventTitle: 'The Edge',
    venueName: 'Hudson Yards',
    'location/address': '30 Hudson Yards, New York, NY 10001',
    latitude: 40.7547,
    longitude: -74.0012,
    category: 'Iconic Landmarks',
    subcategory: 'Observatory',
    startTime: '10:00',
    endTime: '22:00',
    isReservationsNeeded: true,
    typicalHours: '10 AM - 10 PM',
    description: 'New York\'s highest outdoor sky deck with glass floor and breathtaking views.',
    coverArtUrl: '/images/the-edge.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-10',
    eventTitle: 'High Line',
    venueName: 'High Line Park',
    'location/address': 'Gansevoort to 34th St, New York, NY',
    latitude: 40.7483,
    longitude: -74.0047,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '07:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '7 AM - 10 PM',
    description: 'Elevated park built on a historic freight rail line with art installations and city views.',
    coverArtUrl: '/images/high-line.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-11',
    eventTitle: 'Little Island',
    venueName: 'Pier 55',
    'location/address': 'Pier 55 at Hudson River Park, New York, NY',
    latitude: 40.7380,
    longitude: -74.0090,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '06:00',
    endTime: '23:00',
    isReservationsNeeded: false,
    typicalHours: '6 AM - 11 PM',
    description: 'Floating park with unique architecture, performances, and Hudson River views.',
    coverArtUrl: '/images/little-island.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-12',
    eventTitle: 'Muji Cafe in Chelsea',
    venueName: 'Muji Chelsea',
    'location/address': '22 W 19th St, New York, NY 10011',
    latitude: 40.7389,
    longitude: -73.9934,
    category: 'Iconic Landmarks',
    subcategory: 'Shopping',
    startTime: '11:00',
    endTime: '20:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 8 PM',
    description: 'Minimalist Japanese lifestyle store with cafe and unique shopping experience.',
    coverArtUrl: '/images/muji-cafe.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-13',
    eventTitle: 'Washington Square Park',
    venueName: 'Washington Square Park',
    'location/address': 'Waverly Pl & 5th Ave, New York, NY 10011',
    latitude: 40.7308,
    longitude: -73.9975,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: 'Public Park',
    description: 'Historic Greenwich Village park with iconic arch and vibrant community life.',
    coverArtUrl: '/images/washington-square.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-14',
    eventTitle: 'Madison Square Park',
    venueName: 'Madison Square Park',
    'location/address': '23rd St & 5th Ave, New York, NY 10010',
    latitude: 40.7414,
    longitude: -73.9897,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: 'Public Park',
    description: 'Historic park with art installations, food vendors, and Flatiron Building views.',
    coverArtUrl: '/images/madison-square.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-15',
    eventTitle: 'Union Square Greenmarket',
    venueName: 'Union Square Park',
    'location/address': 'Union Square Park, New York, NY 10003',
    latitude: 40.7357,
    longitude: -73.9905,
    category: 'Iconic Landmarks',
    subcategory: 'Market',
    startTime: '08:00',
    endTime: '18:00',
    isReservationsNeeded: false,
    typicalHours: 'Mon/Wed/Fri/Sat 8 AM - 6 PM',
    description: 'New York\'s most famous farmers market with local produce and artisanal goods.',
    coverArtUrl: '/images/union-square-market.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-16',
    eventTitle: 'Gangsters and Ghosts Tour',
    venueName: 'Chinatown/LES',
    'location/address': 'Varies (Chinatown/LES focus)',
    latitude: 40.7144,
    longitude: -73.9986,
    category: 'Iconic Landmarks',
    subcategory: 'Tours',
    startTime: '19:00',
    endTime: '22:00',
    isReservationsNeeded: true,
    typicalHours: 'Evening Tours Varies',
    description: 'Explore the dark history of New York\'s underworld on this fascinating walking tour.',
    coverArtUrl: '/images/gangsters-tour.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-17',
    eventTitle: 'Brooklyn Bridge Park',
    venueName: 'DUMBO/Brooklyn Heights',
    'location/address': 'DUMBO/Brooklyn Heights, Brooklyn, NY 11201',
    latitude: 40.7027,
    longitude: -73.9904,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: '24/7 (Park)',
    description: 'Waterfront park with stunning Manhattan skyline views and recreational activities.',
    coverArtUrl: '/images/brooklyn-bridge-park.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-18',
    eventTitle: 'Staten Island Ferry',
    venueName: 'Whitehall Terminal',
    'location/address': 'Whitehall Terminal, New York, NY 10004',
    latitude: 40.7011,
    longitude: -74.0135,
    category: 'Iconic Landmarks',
    subcategory: 'Transportation',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: '24/7 (Free)',
    description: 'Free ferry ride with spectacular views of the Statue of Liberty and Manhattan skyline.',
    coverArtUrl: '/images/staten-island-ferry.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-19',
    eventTitle: 'Rockefeller Park',
    venueName: 'Battery Park City',
    'location/address': 'Battery Park City, New York, NY 10280',
    latitude: 40.7161,
    longitude: -74.0151,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: 'Public Park',
    description: 'Waterfront park with playgrounds, gardens, and Hudson River views.',
    coverArtUrl: '/images/rockefeller-park.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-20',
    eventTitle: 'Central Park',
    venueName: 'Central Park',
    'location/address': '59th St to 110th St, New York, NY',
    latitude: 40.7850,
    longitude: -73.9683,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: 'Public Park',
    description: 'New York\'s most famous park with lakes, gardens, and countless attractions.',
    coverArtUrl: '/images/central-park.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-21',
    eventTitle: 'Theodore Roosevelt Park',
    venueName: 'American Museum of Natural History',
    'location/address': '81st St & Columbus Ave, New York, NY 10024',
    latitude: 40.7818,
    longitude: -73.9733,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: 'Public Park',
    description: 'Park surrounding the American Museum of Natural History with dinosaur sculptures.',
    coverArtUrl: '/images/theodore-roosevelt-park.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-22',
    eventTitle: 'Conservatory Garden',
    venueName: 'Central Park',
    'location/address': '104th St & 5th Ave, New York, NY 10029',
    latitude: 40.7932,
    longitude: -73.9518,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '08:00',
    endTime: '19:00',
    isReservationsNeeded: false,
    typicalHours: '8 AM - Dusk',
    description: 'Formal garden in Central Park with seasonal displays and peaceful atmosphere.',
    coverArtUrl: '/images/conservatory-garden.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-23',
    eventTitle: 'Morningside Park',
    venueName: 'Morningside Park',
    'location/address': '110th St to 123rd St, New York, NY',
    latitude: 40.8066,
    longitude: -73.9585,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: 'Public Park',
    description: 'Historic park with waterfalls, playgrounds, and community gardens.',
    coverArtUrl: '/images/morningside-park.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-landmark-24',
    eventTitle: 'Bryant Park',
    venueName: 'Bryant Park',
    'location/address': '42nd St & 6th Ave, New York, NY 10018',
    latitude: 40.7538,
    longitude: -73.9835,
    category: 'Iconic Landmarks',
    subcategory: 'Public Space',
    startTime: '07:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '7 AM - 10 PM',
    description: 'Midtown park with seasonal activities, food kiosks, and free events.',
    coverArtUrl: '/images/bryant-park.jpg',
    isFlexible: true,
    region: 'NYC'
  },

  // FOOD: DELIS/GLOBAL (37 locations)
  {
    id: 'nyc-food-1',
    eventTitle: 'Grand Central Oyster Bar',
    venueName: 'Grand Central Terminal',
    'location/address': 'Grand Central Terminal, New York, NY 10017',
    latitude: 40.7525,
    longitude: -73.9772,
    category: 'Food & Dining',
    subcategory: 'Seafood',
    startTime: '11:30',
    endTime: '21:30',
    isReservationsNeeded: true,
    typicalHours: '11:30 AM - 9:30 PM',
    description: 'Historic seafood restaurant in Grand Central with fresh oysters and classic dishes.',
    coverArtUrl: '/images/oyster-bar.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-2',
    eventTitle: 'Katz Delicatessen',
    venueName: 'Katz Delicatessen',
    'location/address': '205 E Houston St, New York, NY 10002',
    latitude: 40.7223,
    longitude: -73.9873,
    category: 'Food & Dining',
    subcategory: 'Deli',
    startTime: '08:00',
    endTime: '23:00',
    isReservationsNeeded: false,
    typicalHours: '8 AM - 11 PM (Sun-Thurs), 24 hours (Fri/Sat)',
    description: 'World-famous deli known for pastrami sandwiches and classic New York deli experience.',
    coverArtUrl: '/images/katz-deli.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-3',
    eventTitle: 'Russ and Daughters',
    venueName: 'Russ and Daughters',
    'location/address': '179 E Houston St, New York, NY 10002',
    latitude: 40.7223,
    longitude: -73.9881,
    category: 'Food & Dining',
    subcategory: 'Deli',
    startTime: '08:00',
    endTime: '16:00',
    isReservationsNeeded: false,
    typicalHours: '8 AM - 4 PM',
    description: 'Iconic Jewish deli specializing in smoked fish, bagels, and traditional appetizing.',
    coverArtUrl: '/images/russ-daughters.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-4',
    eventTitle: 'Pierozek (Polish)',
    venueName: 'Pierozek',
    'location/address': '59 2nd Ave, New York, NY 10003',
    latitude: 40.7275,
    longitude: -73.9888,
    category: 'Food & Dining',
    subcategory: 'Polish',
    startTime: '12:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 10 PM',
    description: 'Authentic Polish restaurant serving pierogi, kielbasa, and traditional Eastern European dishes.',
    coverArtUrl: '/images/pierozek.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-5',
    eventTitle: 'Karczma',
    venueName: 'Karczma',
    'location/address': '136 Greenpoint Ave, Brooklyn, NY 11222',
    latitude: 40.7324,
    longitude: -73.9546,
    category: 'Food & Dining',
    subcategory: 'Polish',
    startTime: '12:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 10 PM',
    description: 'Rustic Polish tavern with hearty traditional dishes and authentic atmosphere.',
    coverArtUrl: '/images/karczma.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-6',
    eventTitle: 'Pyza',
    venueName: 'Pyza',
    'location/address': '620 Manhattan Ave, Brooklyn, NY 11222',
    latitude: 40.7259,
    longitude: -73.9515,
    category: 'Food & Dining',
    subcategory: 'Polish',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 9 PM',
    description: 'Cozy Polish restaurant known for homemade pierogi and traditional comfort food.',
    coverArtUrl: '/images/pyza.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-7',
    eventTitle: 'Veselka',
    venueName: 'Veselka',
    'location/address': '144 2nd Ave, New York, NY 10003',
    latitude: 40.7291,
    longitude: -73.9878,
    category: 'Food & Dining',
    subcategory: 'Ukrainian',
    startTime: '00:00',
    endTime: '23:59',
    isReservationsNeeded: false,
    typicalHours: '24 hours',
    description: 'Iconic Ukrainian diner serving borscht, pierogi, and comfort food 24/7.',
    coverArtUrl: '/images/veselka.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-8',
    eventTitle: 'Nabilas (Lebanese)',
    venueName: 'Nabilas',
    'location/address': '222 Kings Hwy, Brooklyn, NY 11223',
    latitude: 40.6015,
    longitude: -73.9868,
    category: 'Food & Dining',
    subcategory: 'Middle Eastern',
    startTime: '11:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 10 PM',
    description: 'Authentic Lebanese restaurant with fresh hummus, falafel, and traditional Middle Eastern dishes.',
    coverArtUrl: '/images/nabilas.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-9',
    eventTitle: 'Woorijip',
    venueName: 'Woorijip',
    'location/address': '12 W 32nd St, New York, NY 10001',
    latitude: 40.7479,
    longitude: -73.9868,
    category: 'Food & Dining',
    subcategory: 'Korean',
    startTime: '10:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '10 AM - 9 PM',
    description: 'Korean food court with ready-to-eat meals, banchan, and authentic Korean flavors.',
    coverArtUrl: '/images/woorijip.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-10',
    eventTitle: 'Kimganae',
    venueName: 'Kimganae',
    'location/address': '39-12 Union St, Flushing, NY 11354',
    latitude: 40.7620,
    longitude: -73.8290,
    category: 'Food & Dining',
    subcategory: 'Korean',
    startTime: '11:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 10 PM',
    description: 'Korean restaurant in Flushing serving traditional dishes and Korean BBQ.',
    coverArtUrl: '/images/kimganae.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-11',
    eventTitle: 'Doma Korean',
    venueName: 'Doma Korean',
    'location/address': '35 W 35th St, New York, NY 10001',
    latitude: 40.7505,
    longitude: -73.9859,
    category: 'Food & Dining',
    subcategory: 'Korean',
    startTime: '11:30',
    endTime: '21:30',
    isReservationsNeeded: false,
    typicalHours: '11:30 AM - 9:30 PM',
    description: 'Korean restaurant in Midtown with authentic flavors and traditional dishes.',
    coverArtUrl: '/images/doma-korean.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-12',
    eventTitle: 'Little Banchan Shop',
    venueName: 'Little Banchan Shop',
    'location/address': '5-21 47th Ave, Queens, NY 11101',
    latitude: 40.7419,
    longitude: -73.9510,
    category: 'Food & Dining',
    subcategory: 'Korean',
    startTime: '10:00',
    endTime: '19:00',
    isReservationsNeeded: false,
    typicalHours: '10 AM - 7 PM',
    description: 'Korean side dishes shop with fresh banchan and traditional Korean accompaniments.',
    coverArtUrl: '/images/little-banchan.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-13',
    eventTitle: 'Mitsuki Japanese Market',
    venueName: 'Mitsuki',
    'location/address': '504 5th Ave, New York, NY 10018',
    latitude: 40.7530,
    longitude: -73.9840,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '09:00',
    endTime: '19:00',
    isReservationsNeeded: false,
    typicalHours: '9 AM - 7 PM',
    description: 'Japanese market with fresh sushi, bento boxes, and authentic Japanese ingredients.',
    coverArtUrl: '/images/mitsuki.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-14',
    eventTitle: 'Katagiri on 39th',
    venueName: 'Katagiri',
    'location/address': '224 E 39th St, New York, NY 10016',
    latitude: 40.7483,
    longitude: -73.9752,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '10:00',
    endTime: '19:00',
    isReservationsNeeded: false,
    typicalHours: '10 AM - 7 PM',
    description: 'Japanese grocery store with fresh produce, prepared foods, and authentic Japanese products.',
    coverArtUrl: '/images/katagiri.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-15',
    eventTitle: 'Sunrise Mart',
    venueName: 'Sunrise Mart',
    'location/address': '41 E 11th St, New York, NY 10003',
    latitude: 40.7328,
    longitude: -73.9902,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '10:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '10 AM - 9 PM',
    description: 'Japanese convenience store with bento boxes, onigiri, and Japanese snacks.',
    coverArtUrl: '/images/sunrise-mart.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-16',
    eventTitle: 'Hakata Japanese Market',
    venueName: 'Hakata',
    'location/address': '128 W 11th St, New York, NY 10011',
    latitude: 40.7360,
    longitude: -74.0016,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '10:00',
    endTime: '20:00',
    isReservationsNeeded: false,
    typicalHours: '10 AM - 8 PM',
    description: 'Japanese market specializing in Hakata-style ramen and Japanese groceries.',
    coverArtUrl: '/images/hakata.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-17',
    eventTitle: 'Yamadaya',
    venueName: 'Yamadaya',
    'location/address': '533 6th Ave, New York, NY 10011',
    latitude: 40.7380,
    longitude: -73.9982,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '11:00',
    endTime: '20:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 8 PM',
    description: 'Japanese market with fresh sushi, bento, and traditional Japanese foods.',
    coverArtUrl: '/images/yamadaya.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-18',
    eventTitle: 'Yunhai Taiwanese Market',
    venueName: 'Yunhai',
    'location/address': '60 Chrystie St, New York, NY 10002',
    latitude: 40.7153,
    longitude: -73.9950,
    category: 'Food & Dining',
    subcategory: 'Taiwanese',
    startTime: '10:00',
    endTime: '20:00',
    isReservationsNeeded: false,
    typicalHours: '10 AM - 8 PM',
    description: 'Taiwanese market with authentic ingredients, prepared foods, and traditional Taiwanese snacks.',
    coverArtUrl: '/images/yunhai.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-19',
    eventTitle: 'SOBA: Sobaya',
    venueName: 'Sobaya',
    'location/address': '229 E 9th St, New York, NY 10003',
    latitude: 40.7297,
    longitude: -73.9866,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '17:00',
    endTime: '22:00',
    isReservationsNeeded: true,
    typicalHours: '5 PM - 10 PM',
    description: 'Authentic soba noodle restaurant with handmade buckwheat noodles and traditional Japanese dishes.',
    coverArtUrl: '/images/sobaya.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-20',
    eventTitle: 'SOBA: Cocoron',
    venueName: 'Cocoron',
    'location/address': '61 Delancey St, New York, NY 10002',
    latitude: 40.7186,
    longitude: -73.9926,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '11:30',
    endTime: '22:00',
    isReservationsNeeded: true,
    typicalHours: '11:30 AM - 10 PM',
    description: 'Cozy soba restaurant with fresh handmade noodles and traditional Japanese comfort food.',
    coverArtUrl: '/images/cocoron.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-21',
    eventTitle: 'Mariscos El Submarino',
    venueName: 'Mariscos El Submarino',
    'location/address': '158-13 Northern Blvd, Flushing, NY 11358',
    latitude: 40.7675,
    longitude: -73.8055,
    category: 'Food & Dining',
    subcategory: 'Mexican',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 9 PM',
    description: 'Authentic Mexican seafood restaurant with fresh ceviche, tacos, and traditional Mexican dishes.',
    coverArtUrl: '/images/mariscos.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-22',
    eventTitle: 'Kausa',
    venueName: 'Kausa',
    'location/address': '134 Bowery, New York, NY 10013',
    latitude: 40.7176,
    longitude: -73.9947,
    category: 'Food & Dining',
    subcategory: 'Peruvian',
    startTime: '17:00',
    endTime: '22:00',
    isReservationsNeeded: true,
    typicalHours: '5 PM - 10 PM',
    description: 'Peruvian restaurant with authentic ceviche, lomo saltado, and traditional Peruvian flavors.',
    coverArtUrl: '/images/kausa.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-23',
    eventTitle: 'Tamam',
    venueName: 'Tamam',
    'location/address': '111 Division St, New York, NY 10002',
    latitude: 40.7157,
    longitude: -73.9925,
    category: 'Food & Dining',
    subcategory: 'Middle Eastern',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 9 PM',
    description: 'Middle Eastern restaurant with fresh falafel, hummus, and traditional Levantine dishes.',
    coverArtUrl: '/images/tamam.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-24',
    eventTitle: 'Chinatown Ice Cream Factory',
    venueName: 'Chinatown Ice Cream Factory',
    'location/address': '65 Bayard St, New York, NY 10013',
    latitude: 40.7144,
    longitude: -73.9988,
    category: 'Food & Dining',
    subcategory: 'Dessert',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 9 PM',
    description: 'Iconic ice cream shop with unique Asian-inspired flavors like black sesame and red bean.',
    coverArtUrl: '/images/chinatown-ice-cream.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-25',
    eventTitle: 'Rice Pudding at Rice to Riches',
    venueName: 'Rice to Riches',
    'location/address': '37 Spring St, New York, NY 10012',
    latitude: 40.7207,
    longitude: -73.9961,
    category: 'Food & Dining',
    subcategory: 'Dessert',
    startTime: '12:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 10 PM',
    description: 'Specialty rice pudding shop with creative flavors and unique dessert experience.',
    coverArtUrl: '/images/rice-to-riches.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-26',
    eventTitle: 'Malapanda Drypot',
    venueName: 'Malapanda',
    'location/address': '20 E Broadway, New York, NY 10038',
    latitude: 40.7132,
    longitude: -73.9959,
    category: 'Food & Dining',
    subcategory: 'Chinese',
    startTime: '12:00',
    endTime: '23:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 11 PM',
    description: 'Chinese dry pot restaurant with customizable spicy stir-fried dishes.',
    coverArtUrl: '/images/malapanda.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-27',
    eventTitle: 'West Rice Roll King / Yi Ji Shi Mo',
    venueName: 'West Rice Roll King',
    'location/address': '123 Baxter St, New York, NY 10013',
    latitude: 40.7172,
    longitude: -73.9989,
    category: 'Food & Dining',
    subcategory: 'Chinese',
    startTime: '08:00',
    endTime: '19:00',
    isReservationsNeeded: false,
    typicalHours: '8 AM - 7 PM',
    description: 'Authentic Chinese rice roll shop with fresh cheung fun and traditional dim sum.',
    coverArtUrl: '/images/rice-roll-king.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-28',
    eventTitle: 'Peppa\'s Jerk Chicken',
    venueName: 'Peppa\'s Jerk Chicken',
    'location/address': '791 Flatbush Ave, Brooklyn, NY 11226',
    latitude: 40.6559,
    longitude: -73.9599,
    category: 'Food & Dining',
    subcategory: 'Caribbean',
    startTime: '11:00',
    endTime: '23:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 11 PM',
    description: 'Authentic Jamaican jerk chicken with traditional spices and Caribbean flavors.',
    coverArtUrl: '/images/peppas-jerk.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-29',
    eventTitle: 'Amrock Jerk',
    venueName: 'Amrock Jerk',
    'location/address': '118-02 201st St, Queens, NY 11412',
    latitude: 40.6865,
    longitude: -73.7661,
    category: 'Food & Dining',
    subcategory: 'Caribbean',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: 'Varies (Food Truck/Pop-up)',
    description: 'Mobile jerk chicken vendor with authentic Jamaican flavors and traditional preparation.',
    coverArtUrl: '/images/amrock-jerk.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-30',
    eventTitle: 'Takusando',
    venueName: 'Takusando',
    'location/address': 'Varies (Pop-up/Delivery)',
    latitude: 40.7300,
    longitude: -73.9900,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: 'Varies',
    description: 'Pop-up Japanese restaurant with rotating locations and authentic Japanese cuisine.',
    coverArtUrl: '/images/takusando.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-31',
    eventTitle: 'Davelle',
    venueName: 'Davelle',
    'location/address': '102 E 7th St, New York, NY 10009',
    latitude: 40.7262,
    longitude: -73.9850,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '08:00',
    endTime: '16:00',
    isReservationsNeeded: false,
    typicalHours: '8 AM - 4 PM',
    description: 'Japanese cafe with toast specialties, coffee, and light Japanese breakfast items.',
    coverArtUrl: '/images/davelle.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-32',
    eventTitle: 'L\'amico (Lemon Ricotta Pancakes)',
    venueName: 'L\'amico',
    'location/address': '849 6th Ave, New York, NY 10001',
    latitude: 40.7483,
    longitude: -73.9922,
    category: 'Food & Dining',
    subcategory: 'Italian',
    startTime: '11:30',
    endTime: '22:00',
    isReservationsNeeded: true,
    typicalHours: '11:30 AM - 10 PM',
    description: 'Italian restaurant known for lemon ricotta pancakes and authentic Italian cuisine.',
    coverArtUrl: '/images/lamico.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-33',
    eventTitle: 'Dashi Okume',
    venueName: 'Dashi Okume',
    'location/address': '50 Norman Ave, Brooklyn, NY 11222',
    latitude: 40.7323,
    longitude: -73.9515,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '11:00',
    endTime: '19:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 7 PM',
    description: 'Japanese market with fresh dashi, miso, and traditional Japanese ingredients.',
    coverArtUrl: '/images/dashi-okume.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-34',
    eventTitle: 'Hanamizuki',
    venueName: 'Hanamizuki',
    'location/address': '141 E 45th St, New York, NY 10017',
    latitude: 40.7538,
    longitude: -73.9749,
    category: 'Food & Dining',
    subcategory: 'Japanese',
    startTime: '08:00',
    endTime: '17:00',
    isReservationsNeeded: false,
    typicalHours: '8 AM - 5 PM',
    description: 'Japanese market with fresh bento boxes, sushi, and traditional Japanese prepared foods.',
    coverArtUrl: '/images/hanamizuki.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-35',
    eventTitle: 'Sreecha Veselka',
    venueName: 'Sreecha Veselka',
    'location/address': 'Varies (Pop-up/Food Truck)',
    latitude: 40.7300,
    longitude: -73.9870,
    category: 'Food & Dining',
    subcategory: 'Ukrainian',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: 'Varies',
    description: 'Mobile Ukrainian food vendor with traditional pierogi and Eastern European dishes.',
    coverArtUrl: '/images/sreecha-veselka.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-36',
    eventTitle: 'Sigiri Sri Lankan',
    venueName: 'Sigiri',
    'location/address': '91 1st Ave, New York, NY 10003',
    latitude: 40.7302,
    longitude: -73.9877,
    category: 'Food & Dining',
    subcategory: 'Sri Lankan',
    startTime: '17:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '5 PM - 10 PM',
    description: 'Authentic Sri Lankan restaurant with curry, hoppers, and traditional South Asian flavors.',
    coverArtUrl: '/images/sigiri.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-food-37',
    eventTitle: 'Lakruwana Sri Lankan',
    venueName: 'Lakruwana',
    'location/address': '668 Bay St, Staten Island, NY 10304',
    latitude: 40.6277,
    longitude: -74.0682,
    category: 'Food & Dining',
    subcategory: 'Sri Lankan',
    startTime: '12:00',
    endTime: '21:00',
    isReservationsNeeded: true,
    typicalHours: '12 PM - 9 PM',
    description: 'Traditional Sri Lankan restaurant with authentic curry, string hoppers, and South Asian cuisine.',
    coverArtUrl: '/images/lakruwana.jpg',
    isFlexible: true,
    region: 'NYC'
  },

  // FOOD: PIZZA (10 locations)
  {
    id: 'nyc-pizza-1',
    eventTitle: 'LucAli',
    venueName: 'LucAli',
    'location/address': '289 Court St, Brooklyn, NY 11231',
    latitude: 40.6806,
    longitude: -73.9961,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '17:00',
    endTime: '23:00',
    isReservationsNeeded: true,
    typicalHours: '5 PM - 11 PM',
    description: 'Artisanal pizza restaurant with wood-fired oven and creative toppings.',
    coverArtUrl: '/images/lucali.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-pizza-2',
    eventTitle: 'Roberta\'s Pizza',
    venueName: 'Roberta\'s',
    'location/address': '261 Moore St, Brooklyn, NY 11206',
    latitude: 40.7042,
    longitude: -73.9332,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '12:00',
    endTime: '23:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 11 PM',
    description: 'Bushwick pizza institution with creative toppings and wood-fired oven.',
    coverArtUrl: '/images/robertas.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-pizza-3',
    eventTitle: 'Prince Street Pizza',
    venueName: 'Prince Street Pizza',
    'location/address': '27 Prince St, New York, NY 10012',
    latitude: 40.7230,
    longitude: -73.9945,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '11:30',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '11:30 AM - 10 PM',
    description: 'Famous for square slices and spicy pepperoni pizza in SoHo.',
    coverArtUrl: '/images/prince-street-pizza.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-pizza-4',
    eventTitle: 'Rubirosa',
    venueName: 'Rubirosa',
    'location/address': '235 Mulberry St, New York, NY 10012',
    latitude: 40.7233,
    longitude: -73.9943,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '11:00',
    endTime: '23:00',
    isReservationsNeeded: true,
    typicalHours: '11 AM - 11 PM',
    description: 'Thin-crust pizza with creative toppings and Italian-American classics.',
    coverArtUrl: '/images/rubirosa.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-pizza-5',
    eventTitle: 'Scarr\'s Pizza',
    venueName: 'Scarr\'s Pizza',
    'location/address': '22 Orchard St, New York, NY 10002',
    latitude: 40.7151,
    longitude: -73.9912,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '12:00',
    endTime: '01:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 1 AM',
    description: 'Old-school pizza joint with classic New York slices and late-night hours.',
    coverArtUrl: '/images/scarrs.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-pizza-6',
    eventTitle: 'Ace\'s Pizza',
    venueName: 'Ace\'s Pizza',
    'location/address': '275 3rd Ave, New York, NY 10010',
    latitude: 40.7383,
    longitude: -73.9860,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '11:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 10 PM',
    description: 'Neighborhood pizza spot with creative toppings and friendly atmosphere.',
    coverArtUrl: '/images/aces-pizza.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-pizza-7',
    eventTitle: 'Bar 314',
    venueName: 'Bar 314',
    'location/address': '314 Bleecker St, New York, NY 10014',
    latitude: 40.7330,
    longitude: -74.0049,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '17:00',
    endTime: '23:00',
    isReservationsNeeded: false,
    typicalHours: '5 PM - 11 PM',
    description: 'West Village bar with excellent pizza and craft cocktails.',
    coverArtUrl: '/images/bar-314.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-pizza-8',
    eventTitle: 'Bleecker Street Pizza',
    venueName: 'Bleecker Street Pizza',
    'location/address': '69 7th Ave S, New York, NY 10014',
    latitude: 40.7350,
    longitude: -74.0029,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '11:00',
    endTime: '00:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 12 AM',
    description: 'Classic New York pizza with thin crust and traditional toppings.',
    coverArtUrl: '/images/bleecker-street-pizza.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-pizza-9',
    eventTitle: 'NY Pizza Suprema',
    venueName: 'NY Pizza Suprema',
    'location/address': '413 8th Ave, New York, NY 10001',
    latitude: 40.7511,
    longitude: -73.9947,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '11:00',
    endTime: '23:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 11 PM',
    description: 'Midtown pizza institution with classic New York slices and friendly service.',
    coverArtUrl: '/images/ny-pizza-suprema.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-pizza-10',
    eventTitle: 'Mama\'s Too',
    venueName: 'Mama\'s Too',
    'location/address': '2750 Broadway, New York, NY 10025',
    latitude: 40.8037,
    longitude: -73.9691,
    category: 'Food & Dining',
    subcategory: 'Pizza',
    startTime: '12:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 9 PM',
    description: 'Upper West Side pizza spot with square slices and creative toppings.',
    coverArtUrl: '/images/mamas-too.jpg',
    isFlexible: true,
    region: 'NYC'
  },

  // WELLNESS & SPECIALTY DRINKS/TEA/FARM/GREENERY (14 locations)
  {
    id: 'nyc-wellness-1',
    eventTitle: 'AIRE Ancient Baths New York',
    venueName: 'AIRE Ancient Baths',
    'location/address': '88 Franklin St, New York, NY 10013',
    latitude: 40.7188,
    longitude: -74.0041,
    category: 'Wellness & Lifestyle',
    subcategory: 'Spa',
    startTime: '09:00',
    endTime: '23:00',
    isReservationsNeeded: true,
    typicalHours: '9 AM - 11 PM',
    description: 'Luxury thermal baths with ancient Roman-inspired pools and spa treatments.',
    coverArtUrl: '/images/aire-baths.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-2',
    eventTitle: 'Bamford Wellness Spa',
    venueName: 'Bamford Wellness Spa',
    'location/address': '60 Furman St, Brooklyn, NY 11201',
    latitude: 40.6974,
    longitude: -73.9959,
    category: 'Wellness & Lifestyle',
    subcategory: 'Spa',
    startTime: '10:00',
    endTime: '19:00',
    isReservationsNeeded: true,
    typicalHours: '10 AM - 7 PM',
    description: 'Luxury wellness spa with organic treatments and stunning Brooklyn views.',
    coverArtUrl: '/images/bamford-spa.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-3',
    eventTitle: 'QC NY Spa',
    venueName: 'QC NY Spa',
    'location/address': '112 Governors Island Rd, New York, NY 10004',
    latitude: 40.6910,
    longitude: -74.0150,
    category: 'Wellness & Lifestyle',
    subcategory: 'Spa',
    startTime: '10:00',
    endTime: '22:00',
    isReservationsNeeded: true,
    typicalHours: '10 AM - 10 PM',
    description: 'Thermal spa on Governors Island with outdoor pools and city views.',
    coverArtUrl: '/images/qc-ny-spa.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-4',
    eventTitle: 'Guerlain Spa at The Plaza',
    venueName: 'The Plaza Hotel',
    'location/address': '768 5th Ave, New York, NY 10019',
    latitude: 40.7644,
    longitude: -73.9744,
    category: 'Wellness & Lifestyle',
    subcategory: 'Spa',
    startTime: '09:00',
    endTime: '20:00',
    isReservationsNeeded: true,
    typicalHours: '9 AM - 8 PM',
    description: 'Luxury spa at The Plaza Hotel with French beauty treatments and opulent surroundings.',
    coverArtUrl: '/images/guerlain-spa.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-5',
    eventTitle: 'Spa de La Mer at The Baccarat Hotel',
    venueName: 'Baccarat Hotel',
    'location/address': '28 W 53rd St, New York, NY 10019',
    latitude: 40.7601,
    longitude: -73.9780,
    category: 'Wellness & Lifestyle',
    subcategory: 'Spa',
    startTime: '09:00',
    endTime: '20:00',
    isReservationsNeeded: true,
    typicalHours: '9 AM - 8 PM',
    description: 'Ultra-luxury spa with La Mer treatments and crystal-inspired design.',
    coverArtUrl: '/images/la-mer-spa.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-6',
    eventTitle: 'Spa 88',
    venueName: 'Spa 88',
    'location/address': '88 Fulton St, New York, NY 10038',
    latitude: 40.7093,
    longitude: -74.0069,
    category: 'Wellness & Lifestyle',
    subcategory: 'Spa',
    startTime: '10:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '10 AM - 9 PM',
    description: 'Affordable spa with massage, facials, and wellness treatments in Lower Manhattan.',
    coverArtUrl: '/images/spa-88.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-7',
    eventTitle: 'I\'Milky',
    venueName: 'I\'Milky',
    'location/address': '992 6th Ave, New York, NY 10018',
    latitude: 40.7505,
    longitude: -73.9877,
    category: 'Wellness & Lifestyle',
    subcategory: 'Tea',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 9 PM',
    description: 'Korean milk tea shop with unique flavors and Instagram-worthy drinks.',
    coverArtUrl: '/images/imilky.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-8',
    eventTitle: 'Teazzi',
    venueName: 'Teazzi',
    'location/address': '181 Centre St, New York, NY 10013',
    latitude: 40.7185,
    longitude: -73.9989,
    category: 'Wellness & Lifestyle',
    subcategory: 'Tea',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 9 PM',
    description: 'Bubble tea shop in Chinatown with authentic Taiwanese flavors and fresh ingredients.',
    coverArtUrl: '/images/teazzi.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-9',
    eventTitle: 'Yifang',
    venueName: 'Yifang',
    'location/address': '10-18 49th Ave, Queens, NY 11101',
    latitude: 40.7441,
    longitude: -73.9535,
    category: 'Wellness & Lifestyle',
    subcategory: 'Tea',
    startTime: '11:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '11 AM - 9 PM',
    description: 'Taiwanese bubble tea chain with fresh fruit teas and traditional flavors.',
    coverArtUrl: '/images/yifang.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-10',
    eventTitle: 'Teapsy',
    venueName: 'Teapsy',
    'location/address': '12 Doyers St, New York, NY 10013',
    latitude: 40.7142,
    longitude: -73.9984,
    category: 'Wellness & Lifestyle',
    subcategory: 'Tea',
    startTime: '12:00',
    endTime: '20:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 8 PM',
    description: 'Artisanal tea shop with premium loose leaf teas and traditional brewing methods.',
    coverArtUrl: '/images/teapsy.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-11',
    eventTitle: 'Teado',
    venueName: 'Teado',
    'location/address': '101 MacDougal St, New York, NY 10012',
    latitude: 40.7298,
    longitude: -74.0003,
    category: 'Wellness & Lifestyle',
    subcategory: 'Tea',
    startTime: '12:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 9 PM',
    description: 'Greenwich Village tea shop with organic teas and wellness-focused beverages.',
    coverArtUrl: '/images/teado.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-12',
    eventTitle: 'Xin Fu Tang',
    venueName: 'Xin Fu Tang',
    'location/address': '32-55 Francis Lewis Blvd, Queens, NY 11358',
    latitude: 40.7745,
    longitude: -73.7840,
    category: 'Wellness & Lifestyle',
    subcategory: 'Tea',
    startTime: '12:00',
    endTime: '22:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 10 PM',
    description: 'Taiwanese brown sugar bubble tea with hand-made tapioca pearls.',
    coverArtUrl: '/images/xin-fu-tang.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-13',
    eventTitle: 'Machi',
    venueName: 'Machi',
    'location/address': '177 Mott St, New York, NY 10013',
    latitude: 40.7196,
    longitude: -73.9961,
    category: 'Wellness & Lifestyle',
    subcategory: 'Tea',
    startTime: '12:00',
    endTime: '21:00',
    isReservationsNeeded: false,
    typicalHours: '12 PM - 9 PM',
    description: 'Chinatown tea shop with traditional Chinese teas and bubble tea variations.',
    coverArtUrl: '/images/machi.jpg',
    isFlexible: true,
    region: 'NYC'
  },
  {
    id: 'nyc-wellness-14',
    eventTitle: 'Te Company',
    venueName: 'Te Company',
    'location/address': '163 W 10th St, New York, NY 10014',
    latitude: 40.7360,
    longitude: -74.0043,
    category: 'Wellness & Lifestyle',
    subcategory: 'Tea',
    startTime: '13:00',
    endTime: '18:00',
    isReservationsNeeded: false,
    typicalHours: '1 PM - 6 PM (Varies)',
    description: 'Intimate tea house with premium Taiwanese oolongs and traditional tea service.',
    coverArtUrl: '/images/te-company.jpg',
    isFlexible: true,
    region: 'NYC'
  }
];

// Export category mapping for easy reference
export const NYC_CATEGORIES = {
  'Iconic Landmarks': {
    color: '#3B82F6', // Blue
    subcategories: ['Tours', 'Observatory', 'Cultural', 'Public Space', 'Market', 'Shopping', 'Transportation']
  },
  'Food & Dining': {
    color: '#EF4444', // Red
    subcategories: ['Seafood', 'Deli', 'Polish', 'Ukrainian', 'Middle Eastern', 'Korean', 'Japanese', 'Taiwanese', 'Chinese', 'Caribbean', 'Peruvian', 'Dessert', 'Italian', 'Sri Lankan', 'Pizza']
  },
  'Wellness & Lifestyle': {
    color: '#10B981', // Green
    subcategories: ['Spa', 'Tea']
  }
};

// Export region info
export const NYC_REGION_INFO = {
  name: 'New York City',
  center: [40.7589, -73.9851],
  zoom: 11,
  bounds: [
    [40.4774, -74.2591], // Southwest
    [40.9176, -73.7004]  // Northeast
  ]
};
